const PAYMENT_TYPES = [
  {
    label: 'Master Card',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'mastercard',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Account',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'account',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Apple Pay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'applePay',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Barter Card',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'bartercard',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'BPay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'bpay',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Cash',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'cash',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Cheque',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'cheque',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Direct Debit',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'directDebit',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'EFT',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'eft',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Eftpos',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'eftpos',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Fully Insured',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'fullyInsured',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Gift Voucher',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'giftVoucher',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Google Pay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'googlePay',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Visa',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'visa',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Amex',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'amex',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Hicaps',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'hicaps',
    icon: 'icon-categoryprofessionalservices',
  },
  {
    label: 'PayPal',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'payPal',
    icon: 'icon-categorypaymenttypemobile',
  },
  {
    label: 'Seniors Discounts',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'seniorsDiscount',
    icon: 'icon-categoryorganisations',
  },
  {
    label: 'Bulk Billing',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'bulkBilling',
    icon: 'icon-categoryplaceofworship',
  },
  {
    label: 'Bitcoin',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'bitcoin',
    icon: 'icon-categorycarparkpayanddisplay',
  },
  {
    label: 'OpenPay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'openpay',
    icon: 'icon-categorypaymenttypecards',
  },
  {
    label: 'Zip Pay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'zipPay',
    icon: 'icon-categorycarparkpayanddisplay',
  },
  {
    label: 'AfterPay',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'afterPay',
    icon: 'icon-categorycarparkpayanddisplay',
  },
  {
    label: 'Humm',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'humm',
    icon: 'icon-categorycarparkpayanddisplay',
  },
  {
    label: 'Interest Free',
    type: 'paymentType',
    count: 0,
    checked: false,
    key: 'interestFreePlans',
    icon: 'icon-generalquote',
  },
];

const TRADING_HOURS = [
  {
    label: 'Open Now',
    type: 'tradingHours',
    count: 0,
    checked: false,
    key: 'open',
    icon: 'icon-clock',
  },
  {
    label: 'Open 24/7',
    type: 'tradingHours',
    count: 0,
    checked: false,
    key: 'open247',
    icon: 'icon-history',
  },
];
const SORT = [
  {
    label: 'Suggested',
    type: 'sort',
    count: 0,
    checked: false,
    key: 'suggested',
    icon: 'icon-generalsearchlarge',
  },
  {
    label: 'Near Me',
    type: 'sort',
    count: 0,
    checked: false,
    key: 'distance',
    icon: 'icon-generalpindropmini',
  },
];
const FILTERS = [...PAYMENT_TYPES, ...TRADING_HOURS, ...SORT];

export { PAYMENT_TYPES, TRADING_HOURS, SORT, FILTERS };
